import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Services from './views/Services.vue';
import ServicesAcademy from './views/ServicesAcademy.vue';
import ServicesBiotechPharma from './views/ServicesBiotechPharma.vue';
import ServicesManagement from './views/ServicesManagement.vue';
import ServicesActivities from './views/ServicesActivities.vue';
import PageNotFound from './views/PageNotFound.vue';
import About from './views/About.vue';
import Contact from './views/Contact.vue';
import PrivacyPolicy from './views/PrivacyPolicy.vue';
import Login from './views/Login.vue';
import Register from './views/Register.vue';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/services',
      name: 'services',
      component: Services
    },
    {
      path: '/services-academy',
      name: 'services-academy',
      component: ServicesAcademy
    },
    {
      path: '/services-biotech-pharma',
      name: 'services-biotech-pharma',
      component: ServicesBiotechPharma
    },
    {
      path: '/services-management',
      name: 'services-management',
      component: ServicesManagement
    },
    {
      path: '/services-activities',
      name: 'services-activities',
      component: ServicesActivities
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicy
    },
    {
      path: '*',
      name: 'page-not-found',
      component: PageNotFound
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/register',
      component: Register
    },
    {
      path: '/profile',
      name: 'profile',
      // lazy-loaded
      component: () => import('./views/Profile.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      // lazy-loaded
      component: () => import('./views/BoardAdmin.vue')
    },
    {
      path: '/mod',
      name: 'moderator',
      // lazy-loaded
      component: () => import('./views/BoardModerator.vue')
    },
    {
      path: '/user',
      name: 'user',
      // lazy-loaded
      component: () => import('./views/BoardUser.vue')
    }
  ],
  scrollBehavior() {
    return {x: 0, y: 0}
  }
});



// router.beforeEach((to, from, next) => {
//   const publicPages = ['/login', '/register', '/home'];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem('user');

//   // trying to access a restricted page + not logged in
//   // redirect to login page
//   if (authRequired && !loggedIn) {
//     next('/login');
//   } else {
//     next();
//   }
// });